import React from 'react'

import Text from './Text'
import News from './News'
import Showcase from './Showcase'

import styles from './Hero.module.css'

const Hero = () => (
  <div className={styles.container}>
    <Showcase />
    <div className={styles.intro}>
      <div className={styles.roofContainer}>
        <div className={styles.roof} />
      </div>
      <div className={styles.content}>
        <div className={styles.pitch}>
          <h1>We Create,<br/>They Love.</h1>
          <Text size="large" className={styles.copy}>
            We make apps for iOS and Android that people just love to use. Working tight with humongous companies and tiny startups. We fall for brave visions, superb user experiences and digital greatness.
          </Text>
        </div>

        <div className={styles.newsContainer}>
          <div className={styles.news}>
            <News to="https://barbro.com" style="badge" title="New">
              <span>We've just announced <b>Barbro</b></span>
            </News>
            <News to="https://github.com/madebybowtie/FlagKit" style="inline">
              <span>Get <b>FlagKit 2.0</b> on GitHub</span>
            </News>
          </div>
        </div>
      </div>
    </div>
  </div>
)


export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero.js